import Swiper, {
  Navigation,
  EffectFade,
  EffectCreative,
  Keyboard,
  Pagination,
} from 'swiper';
import { Modal } from 'flowbite';

//import 'swiper/css';

(function () {
  /* Variables placed inside of this function will be considered private */
  Swiper.use([Navigation, EffectFade, EffectCreative, Keyboard, Pagination]);
  /* You won't see privateVar in global scope */
  const swipers = document.querySelectorAll('.mySwiper');
  const video = document.getElementById('video');
  const contactModal = document.getElementById('form-modal');
  const hideContactModal = document.getElementById('hide-contact-modal');

  swipers.forEach((s) => {
    let swp;
    if (s.dataset.full) {
      swp = new Swiper(s, {
        slidesPerView: 'auto',
        effect: 'fade',
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    } else {
      swp = new Swiper(s, {
        slidesPerView: 1,
        spaceBetween: 10,
        keyboard: {
          enabled: true,
        },
        rewind: true,

        effect: 'creative',
        lazy: true,
        creativeEffect: {
          prev: {
            shadow: true,
            translate: ['-20%', 0, -1],
          },
          next: {
            translate: ['100%', 0, 0],
          },
        },
        on: {
          transitionStart: function () {
            video.pause();
          },
        },
        breakpoints: {
          '@0.00': {
            slidesPerView: 1,
          },
          '@0.75': {
            slidesPerView: 1,
          },
          '@1.25': {
            slidesPerView: 1,
          },
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    }

    // contact us form integration

    const options = {
      closable: true,
      onHide: () => {},
      onShow: () => {},
    };
    const contactUsModal = new Modal(contactModal, options);

    var currentURL = window.location.href;
    let desiredPart = currentURL.substring(
      currentURL.indexOf('/FinLabs/risktech-ai-accelerator-ebook'),
      currentURL.length
    );
    if (desiredPart == '/FinLabs/risktech-ai-accelerator-ebook/#getintouch') {
      contactUsModal.show();
      swp.slideTo(15);
    }

    if (hideContactModal) {
      hideContactModal.onclick = () => {
        contactUsModal.hide();
      };
    }
    // Check if it has custom nav
    if (s) {
      const menuUl = document.getElementById('ebookMenu');

      // Select all <a> elements inside <li> elements under the parent <ul>
      const aElements = menuUl.querySelectorAll('li a');
      // Convert the NodeList to an array for easier handling
      const links = Array.from(aElements);
      var slides = s.querySelectorAll('.swiper-slide-ebook');
      var slideArray = Array.prototype.slice.call(slides);

      links.forEach((l, i) => {
        l.classList.remove;
        l.onclick = (e) => {
          e.preventDefault();
          // get the slide index by using data-custom-nav-slide
          //data-custom-nav-slideco
          for (i = 0; i < slideArray.length; i++) {
            if (
              slideArray[i].getAttribute('id') ==
              l.getAttribute('href').replace('#', '')
            ) {
              l.focus();

              swp.slideTo(i);
              let screenWidth = screen.width;
              if (screenWidth <= 1180) {
                let mobNavbar = document.querySelector('#navbar-hamburger');
                mobNavbar.classList.toggle('hidden');
                return;
              }
            }
          }
        };
      });

      // Select all <a> elements inside <li> elements under the parent <ul>
      const aIntroElements = document.querySelectorAll(
        '.contents-box-overlay a'
      );
      // Convert the NodeList to an array for easier handling
      const aIntoElements = Array.from(aIntroElements);
      aIntoElements.forEach((l, i) => {
        l.onclick = (e) => {
          e.preventDefault();
          let currentHref = l.getAttribute('href');
          if (
            currentHref == '#riskTech' ||
            currentHref == '#supply' ||
            currentHref == '#climate' ||
            currentHref == '#regulatory' ||
            currentHref == '#kyc' ||
            currentHref == '#itRisk' ||
            currentHref == '#previousAccelerator'
          ) {
            document.getElementById('accelerateBtn').focus();
          }
          if (currentHref == '#finlabs') {
            document.getElementById('finSandBtn').focus();
          }

          for (i = 0; i < aElements.length; i++) {
            if (l.getAttribute('href') == aElements[i].getAttribute('href')) {
              aElements[i].focus();
            }
          }
          // get the slide index by using data-custom-nav-slide
          //data-custom-nav-slideco
          for (i = 0; i < slideArray.length; i++) {
            if (
              slideArray[i].getAttribute('id') ==
              l.getAttribute('href').replace('#', '')
            ) {
              swp.slideTo(i);
              return;
            }
          }
        };
      });
    }
  });

  const swipers2 = document.querySelectorAll('.mySwiper2');

  swipers2.forEach((s) => {
    let swp;
    if (s.dataset.full) {
      swp = new Swiper(s, {
        slidesPerView: 'auto',
        effect: 'fade',
        preventClicks: 'false',
        navigation: {
          nextEl: '.swiper-button-next2',
          prevEl: '.swiper-button-prev2',
        },
      });
    } else {
      swp = new Swiper(s, {
        slidesPerView: 2,
        spaceBetween: 30,
        preventClicks: 'false',
        lazy: true,
        breakpoints: {
          '@0.00': {
            slidesPerView: 2,
          },
          '@0.75': {
            slidesPerView: 2,
          },
          '@1.25': {
            slidesPerView: 2,
          },
        },
        navigation: {
          nextEl: '.swiper-button-next2',
          prevEl: '.swiper-button-prev2',
        },
      });
    }

    // Check if it has custom nav
    if (s.dataset.customNav) {
      let customNav = document.querySelector(`#${s.dataset.customNav}`);
      let links = customNav.querySelectorAll('[data-nav-link]');
      var slides = s.querySelectorAll('.swiper-slide');
      var slideArray = Array.prototype.slice.call(slides);
      links.forEach((l, i) => {
        l.onclick = (e) => {
          e.preventDefault();
          // get the slide index by using data-custom-nav-slide
          //data-custom-nav-slideco
          for (i = 0; i < slideArray.length; i++) {
            if (
              slideArray[i].dataset.customNavSlide ==
              l.getAttribute('href').replace('#', '')
            ) {
              swp.slideTo(i);
              return;
            }
          }
        };
      });
    }
  });

  const swipers3 = document.querySelectorAll('.mySwiper3');

  swipers3.forEach((s) => {
    let swp;
    if (s.dataset.full) {
      swp = new Swiper(s, {
        slidesPerView: 'auto',
        effect: 'fade',
        navigation: {
          nextEl: '.swiper-button-next3',
          prevEl: '.swiper-button-prev3',
        },
      });
    } else {
      swp = new Swiper(s, {
        slidesPerView: 1,
        spaceBetween: 10,
        keyboard: {
          enabled: true,
        },
        rewind: true,
        lazy: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
        },
        breakpoints: {
          '@0.00': {
            slidesPerView: 1,
          },
          '@0.75': {
            slidesPerView: 1,
          },
          '@1.25': {
            slidesPerView: 1,
          },
        },
        navigation: {
          nextEl: '.swiper-button-next3',
          prevEl: '.swiper-button-prev3',
        },
      });
    }

    // Check if it has custom nav
    if (s.dataset.customNav) {
      let customNav = document.querySelector(`#${s.dataset.customNav}`);
      let links = customNav.querySelectorAll('[data-nav-link]');
      var slides = s.querySelectorAll('.swiper-slide');
      var slideArray = Array.prototype.slice.call(slides);

      links.forEach((l, i) => {
        l.onclick = (e) => {
          e.preventDefault();
          // get the slide index by using data-custom-nav-slide
          //data-custom-nav-slideco
          for (i = 0; i < slideArray.length; i++) {
            if (
              slideArray[i].dataset.customNavSlide ==
              l.getAttribute('href').replace('#', '')
            ) {
              swp.slideTo(i);
              return;
            }
          }
        };
      });
    }
  });

  const backgroundLayer = document.querySelectorAll('.backgroundLayer');
  const closeOverlay = document.querySelectorAll('.closeOverlay');

  for (let i = 0; i < backgroundLayer.length; i++) {
    backgroundLayer[i].addEventListener('click', () => {
      backgroundLayer[i].nextElementSibling.classList.remove('hidden');
      backgroundLayer[i]
        .closest('.overlayBackgroud')
        .classList.add('underlayer');
      for (let j = 0; j < closeOverlay.length; j++) {
        closeOverlay[j].addEventListener('click', () => {
          if (j == i) {
            backgroundLayer[i].nextElementSibling.classList.add('hidden');
            backgroundLayer[i]
              .closest('.overlayBackgroud')
              .classList.remove('underlayer');
          }
        });
      }
    });
  }


})();
